import Layout from '../../../fuselage/templates/sa/layout'

import { useState, useEffect } from "react"
import { useRouter } from "next/router"

import { formatInTimeZone } from 'date-fns-tz'

import _ from 'lodash'
import { toHoursAndMinutes } from "../../../lib/agenda-utils"

import { EventsBar } from "../../../ui/site/eventsbar"
import { Header } from '../../../ui/site/header'
import { FHS_SA as header } from '../../../fixtures/nav'
import { Footer } from '../../../fuselage/theme/2025/sa/common/footer/footer'

import { Session, SessionSpeaker, SessionSpeakerGrid } from '../../../fuselage/components/session/session'
import { Button } from "../../../fuselage/components/button/button"
import { Modal } from "../../../fuselage/components/modal/modal"
import { Sidebar } from "../../../fuselage/layout/sidebar/sidebar"
import { Avatar } from '../../../fuselage/components/avatar/avatar'


import SimpleBar from "simplebar-react"
import 'simplebar-react/dist/simplebar.min.css'

import CSS from '../../../css/app/agenda.module.css'


// legacy data imports

import { bzAgendaSettings } from "../../../data/legacy/sa/2023/bz-agenda-settings"
import { bzAgendaSessions } from "../../../data/legacy/sa/2023/bz-agenda-sessions"
import { bzSpeakers } from "../../../data/legacy/sa/2023/bz-speakers"
import { cmsAgendaSettings } from "../../../data/legacy/sa/2023/cms-agenda-settings"


export default function Agenda () {

    const [ currentFilter, setCurrentFilter ] = useState (389592)
    const [ currentDay, setCurrentDay ] = useState (null)
    const [ currentStage, setCurrentStage ] = useState(null)
    const [ showModal, setShowModal ] = useState(false)
    const [ modalContent, setModalContent ] = useState({ avatar: '', name: '', title: '', company: '', bio: ''})

    const router = useRouter()
    
    useEffect( () => {
        if ( router.query.filter ) {
            setCurrentFilter(parseInt(router.query.filter))
        }
    
        if ( router.query.day ) {
            setCurrentDay(parseInt(router.query.day) - 1)
        }
    
    }, [ router ])
    
    
    // 389592 = fhs sessions
    // 388115 = grif sessions
    // 394512 = experiences
    // 399371 = workshops + pitches

    // 388496 = summit stage
    // 388497 = future stage
    // 399370 = exhibition stage
    // 403735 = najd room
    // 403736 = yanbou room
    // 403737 = ballroom B

    // #session-1120700
    
    let mainStreamIds = [ 389592, 388115, 394512, 399371, 388496, 388497, 399370 ]

    // check for global (and untagged) sessions and dump in array

    let globalSessions = ( findGlobalBzSessions( bzAgendaSessions, mainStreamIds ) )

    
    // cms entry data

    const entry = cmsAgendaSettings.data.entry
    const sessionThemes = entry.bizzaboAgendaTheme
    

    
    // console.log('agenda data:', cmsAgendaSettings)
    // console.log('settings:', bzAgendaSettings)
    // console.log('sessions:', sessions)




    // build agenda

    function outputAgenda ( sessions ) {

        let agenda = groupSessionsIntoDays(sessions)

        // console.log('agenda:', agenda)

        if ( currentDay !== null ) {
            // output just one day
            return (
                <>
                    { renderDivider( agenda[currentDay][0].startDate ) }
                    { renderSessions( agenda[currentDay] ) }
                </>
            )

        } else {
            // output all days
            return (
                agenda.map( (day, index) => (
                    <div key={index} className='mb-xs'>
                        { renderDivider( day[0].startDate ) }
                        { renderSessions( day ) }
                    </div>
                ))
            )
            
        }



        // helpers

        function renderDivider ( day ) {
            return (
                <p className='fs-4 fw-600 c-primary bg-theme px-sm py-xs mb-xs'>
                    { day && formatInTimeZone(new Date( day ), 'Asia/Dubai', 'EEEE dd MMMM') }
                </p>
            )
        }

        function renderSessions ( sessions ) {

            // filter sessions (by track)
            if ( currentFilter ) {
                let filteredSessionsByTrack = checkForMainBzSessions( sessions, currentFilter )
                sessions = filteredSessionsByTrack
            }

            // filter sessions (by stage)
            if ( currentStage ) {
                let filteredSessionsByStage = checkForMainBzSessions( sessions, currentStage )
                sessions = _.intersection(sessions, filteredSessionsByStage)
            }

            // render sessions
            if ( sessions.length ) {
                return (
                    sessions.map( session => {

                        let sessionTags = []
    
                        if ( session.filters ) {
                            session.filters.forEach( filter => {
                                filter.tags.forEach( tag =>  sessionTags.push(getSessionTagTitle(tag)) )
                            })
                        }

                        
                        return (
                            <div key={session.id}>
                                {
                                    session.id === 1122241 ?
                                        <p key={`banner${session.id}`} className='fs-4 fw-600 c-primary bg-theme px-sm py-xs mb-xs'>Welcome to Future Hospitality Summit</p>
                                    : ''
                                }

                                {
                                    session.id === 1108935 ?
                                        <div key={`banner${session.id}`} className='pb-sm formatted mb-xs bg-light'>
                                            <p className='fs-4 fw-600 c-primary bg-theme px-sm py-xs mb-xs mt-xs'>FHS Intelligence Talks</p>
                                            <p className='fs-4 fw-600 c-primary pt-xs px-sm'>The Evolution and Trends Facing the Saudi Hospitality Sector</p>
                                            <p className='fw-400 px-sm'>A market snapshot of key trends as they relate to the hospitality sector. Understanding the fundamentals underpinning the market from performance, pipeline, costs, staffing and contracts in line with Vision 2030.  The Den Talks allows each speaker 10 minutes presentation followed by q&a.</p>
                                        </div>
                                    : ''
                                }

                                {
                                    session.id === 1120633 && !currentFilter ?
                                        <p key={`banner${session.id}`} className='fs-4 fw-600 c-primary bg-theme px-sm py-xs mb-xs mt-xs'>Global Restaurant Investment Forum (GRIF) Culinary Tours</p>
                                    : ''
                                }

                                <Session
                                    id={session.id}
                                    startTime={toHoursAndMinutes(session.startMinute)}
                                    endTime={toHoursAndMinutes(session.endMinute)}
                                    tags={sessionTags}
                                    theme={getSessionTheme(sessionTags)}
                                >   
                                    <p className='h3 c-primary'>{ session.title }</p>
                                    
                                    {
                                        session.descriptionHtml &&
                                        <div dangerouslySetInnerHTML={{__html: session.descriptionHtml}} className="mb-xs formatted" />
                                    }

                                    {addSessionCta( session.id )}

                                    <div>{getAllSessionSpeakers(session.speakers)}</div>
        
                                </Session>
                            </div>
                        )
                    })
                )

            
            } else {
                return <p className="fs-6 fw-400">No { getSessionTagTitle(currentFilter) } sessions available {currentStage === 388496 && 'on the Summit Stage for'}{currentStage === 388497 && 'on the Future Stage for'}{currentStage === 399370 && 'on the Exhibition Stage for'}{currentStage === 403735 && 'in the Najd Room for'}{currentStage === 403736 && 'in the Yanbou Room for'}{currentStage === 403737 && 'in the Al Omsiat Ballroom B for'} this day.</p>
            }
            
        }    

        function getAllSessionSpeakers( speakerIds ) {
            
            if ( !speakerIds ) return

            let moderators = []
            let profiles = []

            speakerIds.forEach( speaker => {
                const speakerProfile = bzSpeakers.content.find( obj => obj.id === speaker.speakerId )

                if ( speakerProfile ) {
                    const profile = new SessionSpeakerProfile( 
                        speakerProfile.firstname, 
                        speakerProfile.lastname, 
                        speakerProfile.title,
                        speakerProfile.company,
                        speakerProfile.photoSet ? speakerProfile.photoSet.large : null,
                        speaker.role ? speaker.role : null,
                        speakerProfile.bio 
                    )
                    profile.role === 'Moderator' ? moderators.push( profile ) : profiles.push( profile )
                }
            })

            return (
                <>
                    {
                        moderators.length ?
                            <div>
                                <SessionSpeakerGrid>
                                    { moderators.map( (moderator, index) => handleSpeakerCard( moderator, index) ) }
                                </SessionSpeakerGrid>
                                <p className="fw-500 my-xs c-primary">In conversation with</p>
                            </div>
                        : null
                    }
                    <SessionSpeakerGrid>
                        { profiles.map( (profile, index) => handleSpeakerCard( profile, index) ) }
                    </SessionSpeakerGrid>

                    
                </>
            )

        }

        function addSessionCta( id ) {

            const selectedSessions = [
                { id: 968557, href: "/ae/site-tours#farm", target: '' },
                { id: 968558, href: "/ae/site-tours#lagoon", target: '' }
            ]

            let selectedSession = selectedSessions.find( session => session.id === id)
            let sessionDetails = sessions.find( session => session.id === id)
            
            if ( selectedSession ) {
                return <Button href={selectedSession.href} size={`small`} decal={`fs-sm fw-400 mb-xs no-print`} target={selectedSession.target}>
                    Learn more and register
                </Button>
            }
        }

        function handleSpeakerCard( profile, index) {
            return (
                <span
                    key={index} 
                    onClick={() => {
                        if ( profile.bio ) {
                            setModalContent({
                                avatar: profile.avatarUrl,
                                name: `${profile.firstname} ${profile.lastname}`,
                                title: profile.title,
                                company: profile.company,
                                bio: profile.bio
                            })
                            setShowModal(true)
                        }
                    }}>
                    <SessionSpeaker 
                        avatarUrl={profile.avatarUrl}
                        role={profile.role}
                        firstname={profile.firstname}
                        lastname={profile.lastname}
                        title={profile.title}
                        company={profile.company}
                        bio={profile.bio}
                    />
                </span>
            )
        }

    }


    class SessionSpeakerProfile {
        constructor( firstname, lastname, title, company, avatarUrl, role, bio ) {
            this.firstname = firstname
            this.lastname = lastname
            this.title = title
            this.company = company
            this.avatarUrl = avatarUrl
            this.role = role
            this.bio = bio
        }
    }
   
    function groupSessionsIntoDays ( sessions ) {

        const orderedSessions = _.orderBy(sessions, [ 'startMinute', 'asc'])
        // console.log('orderedSessions:', orderedSessions)
    
        const groupedSessions = _
            .chain(orderedSessions)
            .groupBy(function(session) { return new Date(session.startDate).getDay() })
            .sortBy(function(session) { return session.startMinute })
            .value()
        // console.log('sorted sessions:', groupedSessions)
        // console.log('sorted sessions [1]:', groupedSessions[1])
    
        return groupedSessions
    }


    // tags

    let mergedTags = []

    if ( bzAgendaSettings ) {
        bzAgendaSettings.filters.forEach( obj => {
            obj.tags.forEach( tag => mergedTags.push(tag))
        })
    }

    const getSessionTagTitle = ( id ) => {
        let tag = mergedTags.filter( tag => tag.id == id )
        if ( tag.length ) return tag[0].name
        return
    }

    
    // session theme

    const getSessionTheme = ( bizzaboAgendaTags ) => {

        // check if a cms sessionThemes object exists for bz tag
        const found = sessionThemes.filter( obj => bizzaboAgendaTags.includes( obj.bizzaboAgendaTag ))

        // if yes, return the theme color
        if ( found.length ) return found[0].color
        
        // otherwise return a fallback
        return '#7a4afd'
    }

    
    // filter query reset

    function clearQuery() {
        router.replace('/sa/2023/agenda', undefined, { shallow: true })
    }


    // check bz agenda settings data for specific tag group

    function searchBzFilters( filterData, targetFilterName ) {

        if ( !filterData || !targetFilterName ) return

        let isolatedFilter = []

        filterData.some( arr => {
            if ( arr.name === targetFilterName ) isolatedFilter = arr.tags
        })
        
        return isolatedFilter
    }


    // find global sessions ( to be included in all main streams )
    
    function findGlobalBzSessions ( sessionIds, streamIds ) {

        if ( !sessionIds ) return
        
        let globalSessionIds = []
    
        sessionIds.forEach( session => {
            // check for filters
            if (session.filters) {                
                session.filters.forEach( filter => {
                    // check for tags
                    if (filter.tags) {
                        // check for main stream tags
                        // if no main stream tags are found, push into array
                        if ( !_.intersection(filter.tags, streamIds) ) globalSessionIds.push(session)
                    }
                })
            }
    
            if (!session.filters) {
                // if no filters + tags are found, push into array
                globalSessionIds.push(session)
            }
        })

        // console.log('global sessions: ', globalSessionIds)
        
        return globalSessionIds
        
    }


    // check if bz filter is allocated as main (for filtering)

    function checkForMainBzSessions ( bxSessions, bxFilterId ) {
        let snapshot = bxSessions.filter( session => {
            // for sessions with filter + tags
            if (session.filters) {
                if ( 
                    session.filters[0].tags.includes(parseInt(bxFilterId)) || 
                    session.filters[1] && session.filters[1].tags.includes(parseInt(bxFilterId)) ||
                    globalSessions && globalSessions.includes(session)
                ) return session
            } 
            // for sessions without filters
            else if ( globalSessions && globalSessions.includes(session) ) {
                return session
            }
            
        })
        return snapshot
    }
    



    return (
        <>
            <EventsBar site={'/sa'} />
            <Header
				site={`/sa`}
                handle={`Saudi Arabia`}
                event={header.data.event}
				mainMenu={header.data.mainMenu}
				ctas={header.data.event.headerCtas}
            />


            <section className="block">
                {/* filter */}
                <div className="container">
                    <p className="fs-0 fw-600 c-primary">Agenda</p>

                    <div className={CSS.filterLayout}>

                        {/* track buttons */}
                        <section className={CSS.filterLayoutButtons}>
                            
                            <button 
                                className={`${CSS.filterButton} ${ currentFilter === 389592 ? CSS.active : null }`} 
                                onClick={ () => {
                                    setCurrentFilter(389592)
                                    clearQuery()
                                }}
                            >FHS</button>

                            <button 
                                className={`${CSS.filterButton} ${ currentFilter === 388115 ? CSS.active : null }`} 
                                onClick={ () => {
                                    setCurrentFilter(388115)
                                    clearQuery()
                                }}
                            >GRIF</button>
                           
                            <button 
                                className={`${CSS.filterButton} ${ currentFilter === 394512 ? CSS.active : null }`} 
                                onClick={ () => {
                                    setCurrentFilter(394512)
                                    clearQuery()
                                }}
                            >Experiences</button>

                            <button 
                                className={`${CSS.filterButton} ${ currentFilter === null ? CSS.active : null }`} 
                                onClick={ () => {
                                    setCurrentFilter(null)
                                    clearQuery()
                                }}
                            >All</button>
    
                        </section>


                        {/* day buttons */}
                        <section className={CSS.filterLayoutButtons}>
                            
                            {
                                groupSessionsIntoDays(bzAgendaSessions).map( (day, index) => {
                                    return (
                                        <button 
                                            className={`
                                                ${CSS.filterButton} 
                                                ${ currentDay === index ? CSS.active : null }
                                            `}
                                            key={index} 
                                            onClick={ () => {
                                                setCurrentDay(index)
                                                clearQuery()
                                            }}
                                        >Day { index + 1 }</button>
                                    )
                                })
                            }
                            <button 
                                className={`${CSS.filterButton} ${ currentDay === null ? CSS.active : null }`} 
                                onClick={ () => {
                                    setCurrentDay(null)
                                    clearQuery()
                                }}
                            >All</button>

                        </section>

                        {/* stage select dropdown */}
                        <section className={CSS.filterLayoutButtons}>
                            {/* <p className={`${CSS.desktopOnly} fw-400 c-primary`}>Filter:&emsp;</p> */}
                            <select
                                className={CSS.filterSelect} 
                                defaultValue=""
                                onChange={ (e) => {
                                    setCurrentStage( parseInt(e.target.value) )
                                    clearQuery()
                                    // console.log('selected filter:', e.target.value)
                                }}
                            >
                                <option value="">All stages</option>
                                {
                                    bzAgendaSettings &&
                                    searchBzFilters( bzAgendaSettings.filters, 'Stages').map( filter => {
                                        return (
                                            <option key={filter.id} value={filter.id}>
                                                {filter.name}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </section> 
  
                    </div>
                </div>

                {/* programme */}
                <div className="container">
                    {outputAgenda( bzAgendaSessions )}
                </div>
            </section>



            <Modal onClose={() => setShowModal(false)} show={showModal}>

                <Sidebar size={`medium`}>
                    <aside className="center">
                        {
                            modalContent.avatar ?
                                <Avatar src={modalContent.avatar}/>
                                :
                                <Avatar src={`/assets/ui/avatar-fallback.png`}/>
                        }
                        <p className="fs-5 fw-600 c-primary mt-sm lh-1">{ modalContent.name }</p>
                        <p className="fs-sm fw-400 mt-xs">{modalContent.title} <br/>{modalContent.company}</p>
                    </aside>
                    
                    <SimpleBar style={{ maxHeight: 300 }}>
                        <div className="formatted pr-xs" dangerouslySetInnerHTML={{ __html: modalContent.bio }}></div>
                    </SimpleBar>                            
                    
                </Sidebar>

            </Modal>

            <Footer />

        </>
    )
}


Agenda.getLayout = function getLayout( page ) {
	return (
		<Layout>
			{ page }
		</Layout>
	)
}